import discrepancy from './discrepancy'
import osi from './osi'

const columns = {
  pacing: [
    {
      align: 'start',
      class: 'top-level-ad-unit-id',
      columnName: 'Top-Level Ad Unit IDs',
      columnValue: (item) => {
        const { topLevelAdUnitIds } = item
        return Array.isArray(topLevelAdUnitIds) ? topLevelAdUnitIds.join(', ') : topLevelAdUnitIds
      },
      exportOnly: false,
      fieldType: 'strict',
      formatAs: null,
      isLinkExternal: true,
      key: 'topLevelAdUnitIds',
      linkProperty: null,
      minWidth: 90,
      required: false,
      sortable: true,
      visible: false,
      width: 90,
    },
    {
      align: 'start',
      class: 'top-level-ad-unit-name',
      columnName: 'Top-Level Ad Unit Names',
      columnValue: (item) => {
        const { topLevelAdUnitNames } = item
        return Array.isArray(topLevelAdUnitNames) ? topLevelAdUnitNames.join(', ') : topLevelAdUnitNames
      },
      fieldType: 'textual',
      formatAs: null,
      isLinkExternal: true,
      key: 'topLevelAdUnitNames',
      linkProperty: null,
      minWidth: 180,
      required: false,
      sortable: true,
      visible: false,
      width: 180,
    },
    {
      align: 'start',
      class: 'advertiser-name',
      columnName: 'Advertiser',
      columnValue: (item) => item.advertiserName,
      fieldType: 'textual',
      formatAs: null,
      initialSorted: true,
      key: 'advertiserName',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'order-id',
      columnName: 'Order ID',
      columnValue: (item) => item.orderCode,
      exportOnly: false,
      fieldType: 'strict',
      formatAs: null,
      isLinkExternal: true,
      key: 'orderCode',
      linkProperty: 'orderGamLink',
      minWidth: 90,
      required: false,
      sortable: true,
      visible: false,
      width: 90,
    },
    {
      align: 'start',
      class: 'order-name',
      columnName: 'Order',
      columnValue: (item) => item.orderName,
      fieldType: 'textual',
      formatAs: null,
      isLinkExternal: true,
      key: 'orderName',
      linkProperty: 'orderGamLink',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'line-item-id',
      columnName: 'Line Item ID',
      columnValue: (item) => item.lineItemCode,
      exportOnly: false,
      fieldType: 'strict',
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemCode',
      linkProperty: 'lineItemGamLink',
      mergeAs: 'count',
      minWidth: 90,
      required: false,
      sortable: true,
      visible: false,
      width: 90,
    },
    {
      align: 'start',
      class: 'line-item-name',
      columnName: 'Line Item',
      columnValue: (item) => item.lineItemName,
      fieldType: 'textual',
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemName',
      linkProperty: 'lineItemGamLink',
      mergeAs: 'count',
      minWidth: 180,
      required: true,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: osi.getOsiClassName.bind(osi),
      columnName: 'OSI',
      columnValue: (item) => item.osi,
      exportAs: 'percentage',
      fieldType: 'indicator',
      formatAs: 'number',
      minWidth: 105,
      key: 'osi',
      required: false,
      sortable: true,
      width: 105,
    },
    {
      align: 'start',
      class: 'status',
      columnName: 'Status',
      columnValue: (item) => item.status,
      fieldType: 'textual',
      formatAs: null,
      key: 'status',
      mergeAs: 'count',
      minWidth: 130,
      required: false,
      sortable: true,
      width: 130,
    },
    {
      align: 'start',
      class: 'is-missing-creatives',
      columnName: 'Missing Creatives',
      columnValue: (item) => item.isMissingCreatives,
      fieldType: 'boolean',
      formatAs: 'boolean',
      key: 'isMissingCreatives',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'creative-sizes',
      columnName: 'Sizes',
      columnValue: (item) => item.creativeSizes,
      fieldType: 'strict',
      formatAs: null,
      key: 'creativeSizes',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Creative Sizes',
      width: 150,
    },
    {
      align: 'start',
      class: 'start-date',
      columnName: 'Start Date',
      columnValue: (item) => item.startDate,
      fieldType: 'date',
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'startDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'end-date',
      columnName: 'End Date',
      columnValue: (item) => item.endDate,
      fieldType: 'date',
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'endDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'priority',
      columnName: 'Priority',
      columnValue: (item) => item.priority,
      fieldType: 'textual',
      formatAs: null,
      key: 'priority',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'rate',
      columnName: 'Rate',
      columnValue: (item) => item.rate,
      fieldType: 'numerical',
      formatAs: 'currency',
      key: 'rate',
      minWidth: 111,
      required: false,
      sortable: true,
      width: 111,
    },
    {
      align: 'end',
      class: 'booked',
      columnName: 'Booked',
      columnValue: (item) => item.booked,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'booked',
      minWidth: 135,
      required: false,
      sortable: true,
      width: 135,
    },
    {
      align: 'end',
      class: 'delivered',
      columnName: 'Delivered',
      columnValue: (item) => item.delivered,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'delivered',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: 'Delivered To Date',
      width: 145,
    },
    {
      align: 'end',
      class: 'viewable-impressions',
      columnName: 'Viewable Imps',
      columnValue: (item) => item.viewableImpressions,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'viewableImpressions',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: 'Viewable Impressions',
      width: 145,
    },
    {
      align: 'end',
      class: 'impressions-yesterday',
      columnName: 'Imps Yest',
      columnValue: (item) => item.impressionsYesterday,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'impressionsYesterday',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: 'Impressions Yesterday',
      width: 145,
    },
    {
      align: 'end',
      class: 'clicks',
      columnName: 'Clicks',
      columnValue: (item) => item.clicks,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'clicks',
      minWidth: 120,
      required: false,
      sortable: true,
      width: 120,
    },
    {
      align: 'end',
      class: 'ctr',
      columnName: 'CTR',
      columnValue: (item) => item.ctr,
      exportAs: 'percentage',
      fieldType: 'indicator',
      formatAs: 'percentage',
      key: 'ctr',
      minWidth: 120,
      required: false,
      sortable: true,
      width: 120,
    },
    {
      align: 'start',
      class: 'sales-person',
      columnName: 'Sales Person',
      columnValue: (item) => item.salespersonName || 'None',
      fieldType: 'textual',
      formatAs: null,
      key: 'salespersonName',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'trafficker',
      columnName: 'Trafficker',
      columnValue: (item) => item.traffickerName || 'None',
      fieldType: 'textual',
      formatAs: null,
      key: 'traffickerName',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'secondary-trafficker',
      columnName: 'Sec. Traffickers',
      columnValue: (item) => {
        const { secondaryTraffickerNames } = item
        return (secondaryTraffickerNames?.length && secondaryTraffickerNames) || ['None']
      },
      fieldType: 'textual',
      formatAs: null,
      key: 'secondaryTraffickerNames',
      minWidth: 180,
      required: false,
      sortable: true,
      tooltip: 'Secondary Traffickers',
      width: 180,
    },
    {
      align: 'start',
      columnName: 'Custom Fields',
      columnValue: (item) => {
        const { lineItemCustomFields, orderCustomFields } = item.normalized
        const strFalsey = ['null', 'undefined']
        const normalizedOrderCustomFields = strFalsey.indexOf(orderCustomFields) !== -1 ? [] : orderCustomFields || []
        const normalizedLineItemCustomField = strFalsey.indexOf(lineItemCustomFields) !== -1 ? [] : lineItemCustomFields || []
        const customFields = normalizedOrderCustomFields.concat(normalizedLineItemCustomField)
        const getDefaultCustomFields = () => Array.isArray(customFields) && !customFields.length && ['None']
        const getCustomFields = () => Array.isArray(customFields) && customFields.map((customField) => {
          const { cf_name, cf_value } = customField
          return (cf_name && `${cf_name} = ${cf_value}`) || customField
        })

        return getDefaultCustomFields() || getCustomFields() || customFields
      },
      class: 'custom-fields',
      exportAs: (item) => ((Array.isArray(item.customFields) && item.customFields.join(', ')) || item.customFields),
      fieldType: 'textual',
      formatAs: null,
      key: 'customFields',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: 'all-revenue',
      columnName: 'Revenue',
      columnValue: (item) => item.allRevenue,
      fieldType: 'numerical',
      formatAs: 'currency',
      key: 'allRevenue',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'potential-lost-revenue',
      columnName: 'PL $',
      columnValue: (item) => item.potentialLostRevenue,
      fieldType: 'numerical',
      formatAs: 'currency',
      key: 'potentialLostRevenue',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Potential Lost Revenue',
      width: 150,
    },
    {
      align: 'end',
      class: 'potential-lost-revenue-percentage',
      columnName: 'PL %',
      columnValue: (item) => item.potentialLostRevenuePercentage,
      fieldType: 'numerical',
      formatAs: 'percentage',
      key: 'potentialLostRevenuePercentage',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Potential Lost Revenue %',
      width: 150,
    },
  ],
  discrepancy: [
    {
      align: 'start',
      class: 'advertiser-code',
      columnName: 'Advertiser ID',
      columnValue: (item) => item.advertiserCode,
      exportOnly: true,
      fieldType: 'strict',
      formatAs: null,
      initialSorted: true,
      key: 'advertiserCode',
      minWidth: 105,
      required: false,
      sortable: true,
      width: 105,
    },
    {
      align: 'start',
      class: 'advertiser-name',
      columnName: 'Advertiser',
      columnValue: (item) => item.advertiserName,
      fieldType: 'textual',
      formatAs: null,
      initialSorted: true,
      key: 'advertiserName',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-id',
      columnName: 'Order ID',
      columnValue: (item) => item.orderCode,
      exportOnly: false,
      fieldType: 'strict',
      formatAs: null,
      isLinkExternal: true,
      key: 'orderCode',
      linkProperty: 'orderGamLink',
      minWidth: 105,
      required: false,
      sortable: true,
      visible: false,
      width: 105,
    },
    {
      align: 'start',
      class: 'order-name',
      columnName: 'Order',
      columnValue: (item) => item.orderName,
      fieldType: 'textual',
      formatAs: null,
      isLinkExternal: true,
      key: 'orderName',
      linkProperty: 'orderGamLink',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'line-item-id',
      columnName: 'Line Item ID',
      columnValue: (item) => item.lineItemCode,
      fieldType: 'strict',
      exportOnly: false,
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemCode',
      linkProperty: 'lineItemGamLink',
      minWidth: 105,
      required: false,
      sortable: true,
      visible: false,
      width: 105,
    },
    {
      align: 'start',
      class: 'line-item-name',
      columnName: 'Line Item',
      columnValue: (item) => item.lineItemName,
      fieldType: 'textual',
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemName',
      linkProperty: 'lineItemGamLink',
      minWidth: 210,
      required: true,
      sortable: true,
      width: 210,
    },
    {
      align: 'end',
      class: 'start-date',
      columnName: 'Start Date',
      columnValue: (item) => item.startDate,
      fieldType: 'date',
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'startDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'end-date',
      columnName: 'End Date',
      columnValue: (item) => item.endDate,
      fieldType: 'date',
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'endDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'osi',
      columnName: 'OSI',
      columnValue: (item) => item.osi,
      fieldType: 'indicator',
      exportAs: 'percentage',
      formatAs: 'number',
      key: 'osi',
      minWidth: 105,
      required: false,
      sortable: true,
      width: 105,
    },
    {
      align: 'end',
      class: 'first-party-delivered',
      columnName: '1st Party Delivered',
      columnValue: (item) => item.localImps,
      fieldType: 'numerical',
      exportAs: 'number',
      formatAs: 'number',
      key: 'localImps',
      minWidth: 189,
      required: false,
      sortable: true,
      width: 189,
    },
    {
      align: 'end',
      class: 'third-party-delivered',
      columnName: '3rd Party Delivered',
      columnValue: (item) => item.thirdPartyImps,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'thirdPartyImps',
      minWidth: 189,
      required: false,
      sortable: true,
      width: 189,
    },
    {
      align: 'end',
      class: 'first-party-clicks',
      columnName: '1st Party Clicks',
      columnValue: (item) => item.localClicks,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'localClicks',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: 'third-party-clicks',
      columnName: '3rd Party Clicks',
      columnValue: (item) => item.thirdPartyClicks,
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'thirdPartyClicks',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: discrepancy.getDiscrepancyClassName.bind(discrepancy),
      columnName: 'Discrepancy',
      columnValue: (item) => {
        const { discrepancyPercentage } = item
        const maxInt = '2147483647'

        return discrepancyPercentage === maxInt ? 'N/A' : discrepancyPercentage
      },
      fieldType: 'indicator',
      formatAs: 'discrepancyPercentage',
      key: 'discrepancyPercentage',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
  ],
  creatives: [
    {
      align: 'start',
      class: 'creative-server',
      columnName: 'Creative Server',
      columnValue: (item) => item.thirdPartyServer,
      fieldType: 'textual',
      formatAs: null,
      key: 'thirdPartyServer',
      sortable: true,
    },
    {
      align: 'start',
      class: 'creative-code',
      columnName: 'Creative ID',
      columnValue: (item) => item.creativeCode,
      fieldType: 'strict',
      isLinkExternal: true,
      formatAs: null,
      key: 'creativeCode',
      linkProperty: 'creativeGamLink',
      sortable: true,
    },
    {
      align: 'start',
      class: 'creative-name',
      columnName: 'Creative Name',
      fieldType: 'textual',
      formatAs: null,
      key: 'creativeName',
      sortable: true,
      columnValue: (item) => item.creativeName,
    },
    {
      align: 'start',
      class: 'creative-third-party-impressions',
      columnName: 'Imps',
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'thirdPartyImps',
      sortable: true,
      columnValue: (item) => item.thirdPartyImps,
    },
    {
      align: 'start',
      class: 'creative-third-party-clicks',
      columnName: 'Clicks',
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'thirdPartyClicks',
      sortable: true,
      columnValue: (item) => item.thirdPartyClicks,
    },
    {
      align: 'start',
      class: 'creative-local-imps',
      columnName: '1st Party Imps',
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'localImps',
      sortable: true,
      columnValue: (item) => item.localImps,
    },
    {
      align: 'start',
      class: 'creative-local-clicks',
      columnName: '1st Party Clicks',
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'localClicks',
      sortable: true,
      columnValue: (item) => item.localClicks,
    },
    {
      align: 'start',
      class: discrepancy.getDiscrepancyClassName,
      columnName: 'Discrepancy',
      fieldType: 'indicator',
      formatAs: 'discrepancyPercentage',
      key: 'discrepancyPercentage',
      sortable: true,
      columnValue: (item) => {
        const { discrepancyPercentage } = item
        const maxInt = '2147483647'

        if (discrepancyPercentage === maxInt) {
          return 'N/A'
        }

        return discrepancyPercentage
      },
    },
  ],
  creativesReport: [
    {
      align: 'start',
      class: 'creative-name',
      columnName: 'Creative Name',
      exportOnly: true,
      fieldType: 'textual',
      formatAs: null,
      key: 'creativeName',
      sortable: true,
      columnValue: (item) => item.creativeName,
    },
    {
      align: 'start',
      class: 'creative-code',
      columnName: 'Creative Code',
      exportOnly: true,
      fieldType: 'strict',
      formatAs: null,
      key: 'creativeCode',
      sortable: true,
      columnValue: (item) => item.creativeCode,
    },
    {
      align: 'start',
      class: 'creative-id',
      columnName: 'Creative Id',
      exportOnly: true,
      fieldType: 'strict',
      formatAs: null,
      key: 'creativeId',
      sortable: true,
      columnValue: (item) => item.creativeId,
    },
    {
      align: 'start',
      class: 'creative-size',
      columnName: 'Creative Size',
      exportOnly: true,
      fieldType: 'strict',
      formatAs: null,
      key: 'creativeSize',
      sortable: true,
      columnValue: (item) => item.creativeSize,
    },
    {
      align: 'start',
      class: 'date',
      columnName: 'Date',
      fieldType: 'date',
      formatAs: 'date',
      key: 'date',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.date,
    },
    {
      align: 'start',
      class: 'impressions',
      columnName: 'Imps',
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'impressions',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.impressions,
    },
    {
      align: 'start',
      class: 'viewable-impressions',
      columnName: 'Viewable Imps',
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'viewableImpressions',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.viewableImpressions,
    },
    {
      align: 'start',
      class: 'viewability',
      columnName: 'Viewability',
      fieldType: 'indicator',
      formatAs: 'percentage',
      key: 'viewabilityPercentage',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.viewabilityPercentage,
    },
    {
      align: 'start',
      class: 'clicks',
      columnName: 'Clicks',
      exportAs: 'number',
      fieldType: 'numerical',
      formatAs: 'number',
      key: 'clicks',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.clicks,
    },
    {
      align: 'start',
      class: 'ctr',
      columnName: 'CTR',
      exportAs: 'percentage',
      fieldType: 'indicator',
      formatAs: 'percentage',
      key: 'ctr',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.ctr,
    },
  ],
}

export default columns
